export default __webpack_public_path__ + "static/media/vision.eecfbf55.jpg";